<template>
    <div class="table-wrapper" style="padding-top: 20px">
        <el-tabs v-model="type" type="card">
            <el-tab-pane label="累计" name="name1">
                <!-- <high-search> -->
                <Form ref="formInline" :model="formInline" inline class="form-list"
                    :label-width="100" label-position="right">
                    <div class="search-right-wrapper">
                        <Button :loading="eLoading" type="primary" style="float:left;" @click="handleExport" icon="ios-exit-outline">导出</Button>
                        <Tooltip placement="right" theme="light" transfer style="margin-left: 15px;float:left;" max-width="initial">
                            <span><Icon type="ios-help-circle-outline" /></span>
                            <ul slot="content">
                                <li> 注：系统支持查询截止2小时之前的考勤数据情况。</li>
                            </ul>
                        </Tooltip>
                        <FormItem label="时间选择:" style="width:286px;text-align:left;">
                            <template>
                                <el-date-picker
                                    class="marL"
                                    v-model="formInline.time"
                                    type="date"
                                    :picker-options="pickerOptions"
                                    placeholder="请选择一天" @change="timeChange"
                                    >
                                </el-date-picker>
                              <!-- <el-date-picker
            class="marL"
            v-model="formInline.time"
            type="daterange"
            format="yyyy-MM-dd"
            :picker-options="pickerOptions0"
              range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            transfer split-panels placeholder="请选择" @on-change="timeChange"> -->
        <!-- </el-date-picker> -->
        </template>
                            <!-- <DatePicker type="daterange" v-model='formInline.time'  transfer split-panels placeholder="请选择" @on-change="timeChange" ></DatePicker>  -->
                        </FormItem>
                        <FormItem class="form-calc" label="项目所在地：" style="width:286px;text-align:left;">
                            <!--<place-select v-model="areaCode"></place-select>-->
                            <Cascader v-model="areaCode" :data="counties" clearable placeholder="请选择地区" change-on-select></Cascader>
                        </FormItem>
                        <Button style="margin-left: 20px;float:right;" @click="handleReset">重置</Button>
                        <Button style="float: right;" type="primary" @click="handleQuery">搜索</Button>
                    </div>
                </Form>
                <!-- </high-search> -->
                <Table border :loading="loading" :columns="tableColumns1" :data="tableData" highlight-row>
                    <template slot-scope="{ row, index }" slot="action">
                        <span class="pointer" type="text" size="small" @click="handleDeal('dataAnalysisDetail', row, 'name1')" v-if="row.areaName !=='合计'">详情</span>
                    </template>
                </Table>
                <!-- <div class="t-page">
                    <Page :total="totalCount" :page-size="pageSize" :current="page"
                        @on-change="changePage" @on-page-size-change="pageSizeChange"
                        show-elevator show-sizer show-total transfer>
                    </Page>
                </div> -->
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<style lang="less">
.table-wrapper{
    .el-tabs__item{
        height: 32px;
        line-height: 32px;
    }
}
.ivu-tooltip-inner{
    max-width: initial;
}
</style>
<script>
    import {mapState} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    import dataTime from '@/components/dataTimeMixin'
    import {format} from "../../../utils/forMat"
    export default {
        mixins: [tableMixin, dataTime],
        data(){
            return {
                areaCode: [],
                counties: [],
                eLoading: false,
                type: 'name1',
                formOutLine1: {
                    startDate:'',
                    endDate:''
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '地区',
                        key: 'areaName',
                        minWidth:100,
                    },
                    {
                        title: '系统纳入在建项目数-新增',
                        key: 'provinceBuildingProjectCount',
                        minWidth:300,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                         return h('div', [
                             h('span', '系统纳入在建项目数-新增'),
                             h('Tooltip', {
                                 props:{
                                     placement: 'right',
                                     theme: 'light',
                                     transfer: true,
                                     content: '是指区域内系统纳入在建项目指定月份的增长数量'
                                 }
                             },[
                                 h('Icon', {
                                     props: {
                                         type: 'ios-help-circle-outline'
                                     }
                                 })
                             ]),

                         ]);
                        }
                    },
                    {
                        title: '项目监管增长率-新增',
                        key: 'projectSuperviseIncrRate',
                        minWidth:300,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '项目监管增长率-新增'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内系统指定月份的项目监管增长率'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),
                            ]);
                        }
                    },
                    {
                        title: '考勤数据的项目数-新增',
                        key: 'addHasAttendanceProjectCount',
                        minWidth:300,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '考勤数据的项目数-新增'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内系统内统计指定月份有考勤数据在建项目的增长数量'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '考勤监管项目增长率',
                        key: 'atendanceSuperviseProjectIncrRate',
                        minWidth:300,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '考勤监管项目增长率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内系统内统计指定月份有考勤数据在建项目监管增长率'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '在建项目数',
                        key: 'buildingCount',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '在建项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统在建状态项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),
                            ]);
                        }
                    },
                   /* {
                        title: '工改系统项目数',
                        key: 'platformBuildingCount',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '工改系统项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期工改系统推送的项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '项目监管率',
                        key: 'superviseRate',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '项目监管率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统在建项目数/工改系统项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },*/
                    {
                        title: '有考勤数据项目数',
                        key: 'hasAttendanceProjectCount',
                        minWidth:120,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '有考勤数据项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统中有考勤数据的项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '考勤项目监管率（更新率）',
                        key: 'atendanceProjectsuperviseRate',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '考勤项目监管率（更新率）'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统中有考勤数据的项目数/系统在建状态项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '无考勤项目数',
                        key: 'noAttendanceProjectCount',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '无考勤项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统中无考勤数据的项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '上班工人数',
                        key: 'workerCount',
                        minWidth:100,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '上班工人数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内统计对应考勤日期有考勤记录的工人数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '有考勤数据项目的平均上班工人数',
                        key: 'averageWorkerCount',
                        minWidth:180,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '有考勤数据项目的平均上班工人数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期的上班工人数/有考勤数据项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    // {
                    //     title: '项目考勤率',
                    //     key: 'projectAttendanceRate',
                    //     minWidth:120,
                    //     align: 'right',
                    //     renderHeader: (h, params) => {
                    //         return h('div', [
                    //             h('span', '项目考勤率'),
                    //             h('Tooltip', {
                    //                 props:{
                    //                     placement: 'right',
                    //                     theme: 'light',
                    //                     transfer: true,
                    //                     content: '有考勤数据项目数/平台在建项目数'
                    //                 }
                    //             },[
                    //                 h('Icon', {
                    //                     props: {
                    //                         type: 'ios-help-circle-outline'
                    //                     }
                    //                 })
                    //             ]),
                    //
                    //         ]);
                    //     }
                    // },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        fixed: 'right',
                        width: 100
                    }
                ],
                tableColumns1:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '地区',
                        key: 'areaName',
                        minWidth:100,
                    },
                    {
                        title: '在建项目数',
                        key: 'buildingCount',
                        minWidth:150,
                        sortable: true,
                        align: 'right',
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '在建项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统在建状态项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),
                            ]);
                        }
                    },
                    /*{
                        title: '工改系统项目数',
                        key: 'platformBuildingCount',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '工改系统项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期工改系统推送的项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '项目监管率',
                        key: 'superviseRate',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '项目监管率'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统在建项目数/工改系统项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },*/
                    {
                        title: '有考勤数据项目数',
                        key: 'hasAttendanceProjectCount',
                        minWidth:120,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '有考勤数据项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统中有考勤数据的项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '考勤项目监管率（更新率）',
                        key: 'atendanceProjectsuperviseRate',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        sortMethod: (a,b, type) => {
                            let na = Number(a.replace('%', ''));
                            let nb = Number(b.replace('%', ''));
                            if(type === 'desc') {
                                return nb - na
                            }else {
                                return na - nb
                            }
                        },
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '考勤项目监管率（更新率）'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统中有考勤数据的项目数/系统在建状态项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '无考勤项目数',
                        key: 'noAttendanceProjectCount',
                        minWidth:150,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '无考勤项目数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期系统中无考勤数据的项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '上班工人数',
                        key: 'workerCount',
                        minWidth:120,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '上班工人数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内统计对应考勤日期有考勤记录的工人数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    {
                        title: '有考勤数据项目的平均上班工人数',
                        key: 'averageWorkerCount',
                        minWidth: 180,
                        align: 'right',
                        sortable: true,
                        renderHeader: (h, params) => {
                            return h('div', [
                                h('span', '有考勤数据项目的平均上班工人数'),
                                h('Tooltip', {
                                    props:{
                                        placement: 'right',
                                        theme: 'light',
                                        transfer: true,
                                        content: '是指区域内截止考勤日期的上班工人数/有考勤数据项目数'
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: 'ios-help-circle-outline'
                                        }
                                    })
                                ]),

                            ]);
                        }
                    },
                    // {
                    //     title: '项目考勤率',
                    //     key: 'projectAttendanceRate',
                    //     minWidth:120,
                    //     align: 'right'
                    // },
                    {
                        title: '操作',
                        slot: 'action',
                        fixed: 'right',
                        align: 'center',
                        width: 100
                    }
                ],
                tableData:[],
                tableData1:[],
                exportData:{
                    size:this.pageSize,
                    current:this.page,
                    areaCode: '',
                },
                pickerOptions1:{
                    disabledDate(time){
                        return time.getTime() > Date.now()-30*24*60*60*1000;
                    }
                }
            }

        },
        computed:{
            ...mapState(['area']),
        },
        created(){
            this.setDefaultDate1();//默认一个月
        },
        mounted(){
            this.init()
        },
        watch: {
            'type'(val) {
                this.getTableData()
            },
            // areaCode: function () {
            //     this.getTableData();
            // },
        },
        methods: {
            init() {
                this.$nextTick(()=>{
                    this.areaCode = []
                    if(JSON.stringify(this.$route.query) != '{}') {
                        let code = this.$route.query.areaCode
                        this.areaCode.push(this.$route.query.areaCode.substring(0, 2) + '0000')
                        if (code.substring(2, 4) != '00') {
                            this.areaCode.push(this.$route.query.areaCode.substring(0, 4) + '00')
                        }
                        if (code.substring(4, 6) != '00') {
                            this.areaCode.push(this.$route.query.areaCode)
                        }
                    } else {
                        this.areaCode.push(this.common.getTenantAreaCode())
                        this.setDefaultDate1(); //默认一个月
                    }
                    this.getCounties()
                    this.getTableData();
                })
            },
            // 项目详细地址
            getCounties() {
                this.axios({
                    method: 'get',
                    url:`/dict/counties?areaCode=${this.common.getTenantAreaCode()}`,
                }).then( (res)=> {
                    this.counties = res.data.data
                })
            },
            // 默认选择上一个月份
           setDefaultDate1(){
                let d1 = new Date
                let year,month,day
                d1.setTime(d1.getTime()-30*24*60*60*1000);
                [year,month,day] = [d1.getFullYear(),d1.getMonth(),d1.getDate()];
                let timeChanges = new Date(year,month,day,0);
                this.formOutLine1.startDate = format(timeChanges,"yyyy-MM");
                this.formOutLine1.endDate = this.formOutLine1.startDate;
           },
            handleReset() {
                this.areaCode = []
                this.areaCode.push(this.common.getTenantAreaCode())
                this.page = 1
                this.formInline = {
                    startDate:'',
                    endDate:''
                }
                this.getTableData()
            },
            handleReset1() {
                this.page = 1
                this.formOutLine1 = {
                    startDate:'',
                    endDate:''
                }
                this.areaCode = this.getCookie('tenantAreaCode')
                this.getTableData()
            },
            startMonth(val) {
                this.formOutLine1.startDate =format(val,"yyyy-MM");
                this.formOutLine1.endDate = format(val,"yyyy-MM");
            },
            // endMonth(val) {
            //     this.formOutLine1.endDate = val
            // },
            timeChange(val) {
                this.formInline.startDate = format(val,"yyyy-MM-dd");
                this.formInline.endDate = format(val,"yyyy-MM-dd");
            },
            //导出
            handleExport(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    size:this.pageSize,
                    current:this.page,
                    areaCode: this.areaCode[this.areaCode.length-1],
                };
                let url = ''
                if(this.type == 'name1') {
                    url = '/projectStatistics/cumulativeList/export'
                }else {
                    url = '/projectStatistics/trendList/export'
                }
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url: url,
                    responseType:'arraybuffer',
                    data: param
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'监管项目统计.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name, row, type){
                let routeName = '';
                if(row.haveChildArea){
                    routeName = 'dataAnalysisDetail'
                }else{
                    routeName = 'dataAnalysisDetailProject'
                }
                this.$router.push({
                    name: routeName,
                    query: {
                        areaCode: row.areaCode,
                        type: type
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    startDate: this.type == 'name1' ? this.formInline.startDate : this.formOutLine1.startDate,
                    endDate: this.type == 'name1' ? this.formInline.endDate : this.formOutLine1.endDate,
                    size:this.pageSize,
                    current:this.page,
                    areaCode: this.areaCode[this.areaCode.length-1],
                };
                let url = ''
                if(this.type == 'name1') {
                    url = '/projectStatistics/cumulativeList'
                }else {
                    url = '/projectStatistics/trendList'
                }
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: url,
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        // this.totalCount = response.data.data.total
                        this.tableData=response.data.data
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped >
.form-calc>>>.ivu-cascader .ivu-cascader-menu-item{
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
}
    .dataTab .ivu-tabs-bar {
        margin-bottom: 0;
        border-bottom: none;
    }
    .colspan11{
        display: block;
        width:47%;
    }
    .colspan2{
        width:5%;
    }
   .marL{
       width:186px;
       height:32px;
   }
   .marL>>>.el-input__inner{
       display: inline-block;
       height:32px;
   }
   .marL>>>.el-icon-date{
       margin-left:-9px;
       font-size: 14px;
       /* margin-top:-8px; */

    color: #C0C4CC;
    float: left;
    line-height: 32px;

   }
   .marL>>>.el-range-separator{
       margin-top:-8px ;
       display: inline-block;
       width:16%;
   }
   .marL >>> .el-range__close-icon{
       margin-top:-8px;
   }
   .marL >>> .el-input__suffix .el-input__icon{
       height:32px;
       line-height: 32px;
   }
</style>
